import { ApolloClient, InMemoryCache, createHttpLink, gql, useMutation, split, from, ApolloLink } from "@apollo/client";
import { stateLink, createErrorLink } from './middlewares';
import { getMainDefinition } from '@apollo/client/utilities';

import { createUploadLink } from 'apollo-upload-client'
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { makeVar, useReactiveVar } from "@apollo/client";
import Notifications from "./../components/notifications/Notifications";
import { serverConfig } from './../api/apiConfig';

export const name = makeVar("Ti Venegas");
//import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
//loadErrorMessages()
//loadDevMessages()


const uri = serverConfig.dev.url + 'graphql'
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );

  if (networkError) console.log(`[Network error]: ${networkError}`);
});
const httpLink = createHttpLink({
  uri,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists

  const token = localStorage.getItem('token');
  console.log(localStorage.getItem("token"));
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      'apollo-require-preflight': true,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});




//const httpLink = new HttpLink({ uri: 'YOUR_GRAPHQL_ENDPOINT' });
const uploadLink: any = createUploadLink({ uri });
const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'mutation'
    );
  },
  uploadLink,
  authLink,
);
const apolloLinks: any = [authLink, createErrorLink(), stateLink, uploadLink];
//const client = new ApolloClient({ link, cache: new InMemoryCache() });

const cache: any = new InMemoryCache();

const client = new ApolloClient({
  //link: authLink.concat(httpLink),
  //link: from(apolloLinks),
  link: ApolloLink.from([authLink, uploadLink]),
  cache,
  queryDeduplication: false,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
  },
  connectToDevTools: true,

});


const AUTH_USER = gql`
      mutation Login($email: String!, $password: String!) {
      
        login(data:{email: $email, password: $password}) {
          token
          renewToken
        }
      }
    `;



const UPDATE_USER = gql`
      mutation UpdateUser($updateUserInput: UpdateUserInput!) {
        updateUser( updateUserInput :  $updateUserInput) {
          name
          email
          _id
          image
          confirmed
          employed
          opentorelocation
          enableScoutingPool
          englishLevel
          country
          uePassport
          company{
            _id
            name
          }
          category{
            _id
            name
          }
          
        }
      }
    `;

const UPDATE_COMPANY = gql`
      mutation UpdateCompany($updateCompanyInput: UpdateCompanyInput!) {
        updateCompany( updateCompanyInput :  $updateCompanyInput) {
          _id
          name
          description
          createdBy{_id, name, role}
          
        }
      }
    `;
const UPDATE_CATEGORY = gql`
      mutation UpdateCategory($updateCategoryInput: UpdateCategoryInput!) {
        updateCategory( updateCategoryInput :  $updateCategoryInput) {
          _id
          name
          description
          createdBy{_id, name, role}
          
        }
      }
    `;
const UPDATE_CARRERGUIDE = gql`
      mutation UpdateCarrerguide($updateCarrerguideInput: UpdateCarrerguideInput!) {
        updateCarrerguide( updateCarrerguideInput :  $updateCarrerguideInput) {
          _id
          name
          description
          createdBy{_id, name, role}
          
        }
      }
    `;
const CREATE_USER = gql`
      mutation CreateUser($createUserInput: CreateUserInput!){
        createUser( createUserInput : $createUserInput) {
          _id
          name
          email
          confirmed
          employed
          opentorelocation
          enableScoutingPool
          englishLevel
          country
          uePassport
        }
      }
    `;
const CHAT_GPT_RESPONSE = gql`
      mutation ChatGptRequest($createChatgptInput: CreateChatgptInput!){
        chatGptRequest( createChatgptInput : $createChatgptInput) {
          _id
          messages{ai, text}
    			type
        }
      }
    `;
const AI_RESUME_FEEDBACK = gql`
      mutation Airesumefeedback($createChatgptInput: CreateChatgptInput!){
        airesumefeedback( createChatgptInput : $createChatgptInput) {
          response
        }
      }
    `;
const AI_URL_FEEDBACK = gql`
      mutation Aiurlresumefeedback($createChatgptInput: CreateChatgptInput!){
        aiurlresumefeedback( createChatgptInput : $createChatgptInput) {
          response
        }
      }
    `;
const AI_URL_COMPANY_FEEDBACK = gql`
      mutation AiurlCompanyfeedback($createChatgptInput: CreateChatgptInput!){
        aiurlCompanyfeedback( createChatgptInput : $createChatgptInput) {
          response
        }
      }
    `;
const CREATE_CREDIT = gql`
      mutation CreateCredit($createCreditInput: CreateCreditInput!){
        createCredit( createCreditInput : $createCreditInput) {
          _id
          amount
        }
      }
    `;
const CREATE_REFERRAL = gql`
      mutation CreateReferral($createReferralInput: CreateReferralInput!){
        createReferral( createReferralInput : $createReferralInput) {
          _id, createdAt, scout{_id name image},scouter{_id name image}, status, active, joblink, company{_id, name}
        }
      }
    `;
const CREATE_PROFILE = gql`
      mutation CreateProfile($createProfileInput: CreateProfileInput!){
        createProfile( createProfileInput : $createProfileInput) {
          _id
          location
          flag
          bio
          yearsOfExperience
          professionalTitle
          educationBackground
          description
          user{
            _id
            name

          }
        }
      }
    `;
const CONFIRM_CODE = gql`
      mutation ConfirmCode($updateUserInput: UpdateUserInput!){
        confirmCode( updateUserInput : $updateUserInput) {
          _id 
          name
          image 
          phone 
          role
          email
          confirmed
          employed
          opentorelocation
          enableScoutingPool
          englishLevel
          country
          uePassport
          company{
            _id
            name
          }
          category{
            _id
            name
          }
        }
      }
    `;
const NEW_PASSWORD = gql`
      mutation NewPassword($updateUserInput: UpdateUserInput!){
        newPassword( updateUserInput : $updateUserInput) {
          _id 
          name
          
        }
      }
    `;
const SEND_PASSWORD = gql`
      mutation SendPasswordEmail($updateUserInput: UpdateUserInput!){
        sendPasswordEmail( updateUserInput : $updateUserInput) {
          _id 
          name
          
        }
      }
    `;
const SEND_INVITE_EMAIL = gql`
      mutation SendInviteEmail($updateUserInput: UpdateUserInput!){
        sendInviteEmail( updateUserInput : $updateUserInput) {
          
          message
          
        }
      }
    `;
const UPDATE_PROFILE = gql`
      mutation UpdateProfile($updateProfileInput: UpdateProfileInput!) {
        updateProfile( updateProfileInput :  $updateProfileInput) {
          _id
          location
          flag
          bio
          yearsOfExperience
          professionalTitle
          educationBackground
          description
          user{
            _id
            name

          }
          
        }
      }
    `;
const UPDATE_TRANSACTION = gql`
      mutation UpdateTransaction($updateTransactionInput: UpdateTransactionInput!) {
        updateTransaction( updateTransactionInput :  $updateTransactionInput) {
          _id
        }
      }
    `;
const UPDATE_CREDIT = gql`
      mutation UpdateCredit($updateCreditInput: UpdateCreditInput!) {
        updateCredit( updateCreditInput :  $updateCreditInput) {
          _id amount
        }
      }
    `;
const CREATE_RECOMMENDATION = gql`
      mutation CreateRecommendation($createRecommendationInput: CreateRecommendationInput!){
        createRecommendation( createRecommendationInput : $createRecommendationInput) {
          _id
          scout{
            _id
            name
          }
          status
          active
          company{
            _id
            name
          }
        }
      }
    `;
const UPDATE_RECOMMENDATION = gql`
    mutation UpdateRecommendation($updateRecommendationInput: UpdateRecommendationInput!) {
      updateRecommendation( updateRecommendationInput :  $updateRecommendationInput) {
        _id
          scout{
            _id
            name
          }
          scouter{
            _id
            name
          }
          status
          active
          company{
            _id
            name
          }
        
      }
    }
  `;
const CREATE_COMPANY = gql`
      mutation CreateCompany($createCompanyInput: CreateCompanyInput!){
        createCompany( createCompanyInput : $createCompanyInput) {
          _id
          name
          description
          createdBy{_id, name}
        }
      }
    `;
const CREATE_TRANSACTION = gql`
      mutation CreateTransaction($createTransactionInput: CreateTransactionInput!){
        createTransaction( createTransactionInput : $createTransactionInput) {
          createdAt
          _id
          message
          email
          planType
          user{_id, name}
          
        }
      }
    `;
const CREATE_CATEGORY = gql`
      mutation CreateCategory($createCategoryInput: CreateCategoryInput!){
        createCategory( createCategoryInput : $createCategoryInput) {
          _id
          name
          
        }
      }
    `;
const CREATE_CARRERGUIDE = gql`
      mutation CreateCarrerguide($createCarrerguideInput: CreateCarrerguideInput!){
        createCarrerguide( createCarrerguideInput : $createCarrerguideInput) {
          _id
          name
          description
        }
      }
    `;
const REMOVE_USER = gql`
      mutation RemoveUser($id: String!){
        removeUser(id : $id) {
          acknowledged
        }
      }
    `;
const REMOVE_COMPANY = gql`
      mutation RemoveCompany($id: String!){
        removeCompany(id : $id) {
          acknowledged
        }
      }
    `;
const REMOVE_CATEGORY = gql`
      mutation RemoveCategory($id: String!){
        removeCategory(id : $id) {
          acknowledged
        }
      }
    `;
const REMOVE_CARRERGUIDE = gql`
      mutation RemoveCarrerguide($id: String!){
        removeCarrerguide(id : $id) {
          acknowledged
        }
      }
    `;

const CREATE_CHAT = gql`
  mutation CreateChat($createChatInput: CreateChatInput!) {
    createChat(createChatInput: $createChatInput) {
      _id
      senderId { _id name image }
      receiverId { _id name image }
      messages { senderId text createdAt }
      updatedAt
    }
  }
`;

const UPDATE_CHAT = gql`
  mutation UpdateChat($updateChatInput: UpdateChatInput!) {
    updateChat(updateChatInput: $updateChatInput) {
      _id
      messages { senderId text createdAt }
    }
  }
`;

const REMOVE_CHAT = gql`
  mutation RemoveChat($id: String!) {
    removeChat(id: $id) {
      _id
    }
  }
`;

const TOGGLE_FAVORITE = gql`
  mutation ToggleFavorite($targetUserId: String!) {
    toggleFavorite(targetUserId: $targetUserId) {
      _id
      favorites
    }
  }
`;

const filterChat: any = async (data: any) => {
  try {
    const query = gql`
      query chatFilter($updateChatInput: UpdateChatInput!) {
        chatFilter(updateChatInput: $updateChatInput) {
          _id
          senderId { _id name image }
          receiverId { _id name image }
          messages { senderId text createdAt }
          updatedAt
        }
      }
    `;
    const result: any = await client.query({
      query: query,
      variables: {
        updateChatInput: data
      },
      fetchPolicy: 'network-only'
    });
    return result.data.chatFilter;
  } catch (error: any) {
    console.log("Error filtering chats", error.message);
    return [];
  }
};


const getCredits: any = async () => {
  try {
    const result = await client
      .query({
        query: gql`
          query getCredits{credits{_id, amount, recommendations[{_id, status, link, active, company }]}}
          `,
      })
      .then((result) => result);
    return result.data.credits;
  }
  catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error get credits", error.message)
  }
}
const getCategories: any = async () => {
  try {
    const result = await client
      .query({
        query: gql`
          query getCategories{categories{_id,  name, createdBy{_id, name, role }}}
          `,
      })
      .then((result) => result);
    return result.data.categories;
  }
  catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error get categories", error.message)
  }
}
const getNewsletter: any = async () => {
  try {
    const result = await client
      .query({
        query: gql`
          query getNewsletter{getNewsletter{_id, createdAt,  email,}}
          `,
      })
      .then((result) => result);
    return result.data.getNewsletter;
  }
  catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error get categories", error.message)
  }
}
const getCarrerguide: any = async () => {
  try {
    const result = await client
      .query({
        query: gql`
          query getCarrerguide{getcarrerguide{_id, createdAt,  name, description, createdBy{_id, name, role }}}
          `,
      })
      .then((result) => result);
    return result.data.getcarrerguide;
  }
  catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error get categories", error.message)
  }
}

const getCompanies: any = async () => {
  try {
    const result = await client
      .query({
        query: gql`
      query getCompanies{companies{_id, createdAt, domain, approved, name,description,category{_id, name} ,image,logos{size, url, type} createdBy{_id, name, role }}}
      `,
      })
      .then((result) => result);
    return result.data.companies;
  }
  catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el getCompanies", error.message)
  }
}
const getInvoices: any = async () => {
  try {
    const result = await client
      .query({
        query: gql`
      query getInvoices{companies{_id, createdAt, name, planType, user{_id, name} ,email, stripe, expiration}}
      `,
      })
      .then((result) => result);
    return result.data.invoices;
  }
  catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el getInvoices", error.message)
  }
}
const getReferrals: any = async () => {
  try {
    const result = await client
      .query({
        query: gql`
      query geReferrals{referrals{_id, createdAt, name,description,category{_id, name} ,image, createdBy{_id, name, role }}}
      `,
      })
      .then((result) => result);
    return result.data.referrals;
  }
  catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el getCompanies", error.message)
  }
}
const getUsers: any = async () => {
  try {
    const result = await client
      .query({
        query: gql`
      query getUsers{users{name,category{_id, name},company{_id, name}, email, _id,confirmed,employed,opentorelocation,enableScoutingPool,country, englishLevel,uePassport, image, phone, role, createdAt}}
    `,
      })
      .then((result) => result);
    return result.data.users;
  }
  catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el usuario", error.message)
  }
}
const getUser: any = () => {
  try {
    client
      .query({
        query: gql`
        query getUser{user{name, email, confirmed,employed,keywords, grade,opentorelocation,enableScoutingPool,country, englishLevel,uePassport, _id, image, phone, role,category{_id, name},company{_id, name}}}
      `,
      })
      .then((result) => console.log(result));
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el usuario", error.message)
  }

}
const getPlans: any = async () => {
  try {
    const query: any = gql`
        query Getplans{
          plans{
            _id createdAt name description price type
          }
        }
      `;



    const result: any = await client.query({
      query: query
    })
    return result.data.plans
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el plans", error.message)
  }

}
const filterCredit: any = async (data: any) => {
  try {
    const query = gql`
    query findCreditByFilter($updateCreditInput: UpdateCreditInput!) {
      creditFilter(updateCreditInput: $updateCreditInput){
        _id, amount, active, user{_id}, recommendations{_id, status, active, link}, chatgpt{_id}, amountInterview, amountPdf
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        updateCreditInput: data
      }
    })
    //console.log(result);
    return result.data.creditFilter
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el usuario", error.message)
    return error.message

  }

}
const filterProfile: any = async (data: any) => {
  try {
    const query = gql`
    query findProfileByFilter($updateProfileInput: UpdateProfileInput!) {
      profileFilter(updateProfileInput: $updateProfileInput){
        _id user{_id name} bio createdAt location flag professionalTitle
        educationBackground
        description yearsOfExperience
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        updateProfileInput: data
      }
    })
    //console.log(result);
    return result.data.profileFilter
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el profile", error.message)
    return error.message

  }

}
const filterChatgpt: any = async (data: any) => {
  try {
    const query = gql`
    query findChatgptByFilter($updateChatgptInput: UpdateChatgptInput!) {
      chatgptFilter(updateChatgptInput: $updateChatgptInput){
        _id user{_id name} createdAt response type job messages{ai,text} message pdf
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        updateChatgptInput: data
      },
      fetchPolicy: 'network-only'
    })
    //console.log('result chatgpt filter',result);
    return result.data.chatgptFilter
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error el chatgpt filter", error.message)
    return error.message

  }

}
const filterUser: any = async (data: any) => {
  try {
    const query = gql`
    query findUserByFilter($updateUserInput: UpdateUserInput!) {
      userFilter(updateUserInput: $updateUserInput){
        _id, name, email, confirmed,employed,keywords, grade,opentorelocation,enableScoutingPool,country, englishLevel,uePassport, image, phone, role,category{_id, name},company{_id, name}, favorites
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        updateUserInput: data
      }
    })
    //console.log(result);
    return result.data.userFilter
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el user", error.message)
    return error.message

  }

}
const findProfileByUser: any = async (data: any) => {
  try {
    const query = gql`
    query findProfileByUser($user: String!) {
      findByUser(user: $user){
        _id user{_id name} bio createdAt location flag professionalTitle
        educationBackground
        description yearsOfExperience pdf
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        user: data
      }
    })
    console.log(result);
    return result.data.findByUser
  } catch (error: any) {
    /* const notData = {
      type: 'error',
      message: 'No user information',
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el profile by user", error.message) */
    return false
  }
}
const verificarStatusCliente: any = async (data: any) => {
  try {
    const query = gql`
    query verificarStatusCliente($id: String!) {
      verificarStatusCliente(id: $id){
        message status
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        id: data.id
      }
    })
    console.log(result);
    return result.data.verificarStatusCliente
  } catch (error: any) {
    return error
  }
}
const cancelarAssinatura: any = async (data: any) => {
  try {
    const query = gql`
    query cancelarAssinatura($id: String!) {
      cancelarAssinatura(id: $id){
        status message
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        id: data.id
      },
      fetchPolicy: 'network-only'
    })
    console.log('cancelarAssinatura result', result);
    return result.data.cancelarAssinatura
  } catch (error: any) {
    return { status: 'erro', message: error.message }
  }
}
const recuperarHistoricoDeCobrancas: any = async (data: any) => {
  try {
    const query = gql`
    query recuperarHistoricoDeCobrancas($id: String!) {
      recuperarHistoricoDeCobrancas(id: $id){
        message status
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        id: data.id
      }
    })
    console.log(result);
    return result.data.recuperarHistoricoDeCobrancas
  } catch (error: any) {
    return error
  }
}
const filterRecommendation: any = async (data: any) => {
  try {
    const query = gql`
    query findRecommendationByFilter($updateRecommendationInput: UpdateRecommendationInput!) {
      recommendationFilter(updateRecommendationInput: $updateRecommendationInput){
        _id, type, message, details, detailsScouter, createdAt,referral{_id email message joblink token status active}, scout{_id name image}, scouter{_id name image}, status, active, link, company{_id, name}
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        updateRecommendationInput: data
      }
    })
    //console.log(result);
    return result.data.recommendationFilter
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener recommendation", error.message)
    return error.message

  }

}
const filterReferral: any = async (data: any) => {
  try {
    const query = gql`
    query findReferralByFilter($updateReferralInput: UpdateReferralInput!) {
      referralFilter(updateReferralInput: $updateReferralInput){
        _id, createdAt, message, email, scouter{_id email name image phone}, scout{_id email name image employed phone}, company{_id, name}, recommendation{_id createdAt link status active }, status, active, joblink
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        updateReferralInput: data
      }
    })
    console.log(result);
    return result.data.referralFilter
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener referral", error)
    return error.message

  }

}


const scrapLink: any = async (data: any) => {
  try {
    const query = gql`
    query scrapLink($createScrapInput: CreateScrapInput!) {
      scrapLink(createScrapInput: $createScrapInput){
        _id, result {
          title
          company
          location
          lastUpdate
          link
        }
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        createScrapInput: data
      }
    })

    return result.data.scrapLink
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    //console.log("Error al obtener scrap", error.message)
    return error.message

  }

}
const scrapFilter: any = async (data: any) => {
  try {
    const query = gql`
    query scrapFilter($updateScrapInput: UpdateScrapInput!) {
      scrapFilter(updateScrapInput: $updateScrapInput){
        _id, result {
          title
          position
          link
          jobUrl
          companyLogo
          company
          location
          agoTime
          lastUpdate
          link
        }
      }
    }
`;
    const result: any = await client.query({
      query: query,
      variables: {
        updateScrapInput: data
      }
    })
    //console.log('result scrapfilter',result);
    return result.data.scrapFilter
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    //console.log("Error al obtener scrapFilter", error.message)
    return error.message

  }

}

const filterCompany: any = async (data: any) => {
  try {
    const query = gql`
  query findByFilter($updateCompanyInput: UpdateCompanyInput!) {
    companyFilter(updateCompanyInput: $updateCompanyInput){
      createdAt, name, _id, image, imageLinkedin, logos{ url, size}, description, createdBy{_id, name}, category{_id, name}
    }
  }
`;

    const result: any = await client.query({
      query: query,
      variables: {
        updateCompanyInput: data
      }
    })
    console.log(result);
    return result.data.companyFilter
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el usuario", error.message)
    return error.message

  }

}
const filterTransaction: any = async (data: any) => {
  try {
    const query = gql`
    query filterTransaction($updateTransactionInput: UpdateTransactionInput!) {
      filterTransaction(updateTransactionInput: $updateTransactionInput){
        createdAt,_id, stripe, email, name, user{_id, name}, message, planType
      }
    }
`;

    const result: any = await client.query({
      query: query,
      variables: {
        updateTransactionInput: data
      }
    })
    console.log('filterTransaction', result);
    return result.data.filterTransaction
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    Notifications(notData)
    console.log("Error al obtener el usuario", error.message)
    return error.message

  }

}

const filterCategory: any = async (data: any) => {
  try {


    const query = gql`
    query findByFilter($updateCategoryInput: UpdateCategoryInput!) {
      companyFilter(updateCategoryInput: $updateCategoryInput){
        createdAt, name, _id, createdBy{_id, name}
      }
    }
  `;

    const result: any = await client.query({
      query: query,
      variables: {
        updateCategoryInput: data
      }
    })
    //console.log(result);
    return result.data.categoryFilter
  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    //Notifications(notData)
    //console.log("Error al obtener el usuario", error.message)
    return error.message

  }

}

const whoami: any = async () => {
  try {
    const result = await client
      .query({
        query: gql`
        query whoami{whoami{ name, keywords, grade, category{ _id, name },company{ _id, name }, confirmed, employed, opentorelocation, enableScoutingPool, country, englishLevel, uePassport, email, _id, image, phone, role, favorites } }
    `,
      })
    return result.data.whoami

  } catch (error: any) {
    const notData = {
      type: 'error',
      message: error.message,
      title: 'wescout',
      timeOut: 2500,
      callback: () => { },
      priority: true,
    }
    //Notifications(notData)
    //console.log("Error al obtener el usuario", error.message)
  }

}

export { client, CREATE_CREDIT, CREATE_REFERRAL, CREATE_PROFILE, CREATE_RECOMMENDATION, UPDATE_CREDIT, UPDATE_RECOMMENDATION, UPDATE_USER, UPDATE_CARRERGUIDE, UPDATE_CATEGORY, SEND_INVITE_EMAIL, SEND_PASSWORD, NEW_PASSWORD, CONFIRM_CODE, UPDATE_PROFILE, UPDATE_COMPANY, REMOVE_COMPANY, REMOVE_CARRERGUIDE, REMOVE_CATEGORY, CREATE_USER, CHAT_GPT_RESPONSE, AI_URL_COMPANY_FEEDBACK, AI_URL_FEEDBACK, AI_RESUME_FEEDBACK, CREATE_CATEGORY, CREATE_TRANSACTION, UPDATE_TRANSACTION, CREATE_CARRERGUIDE, CREATE_COMPANY, getPlans, getUsers, getUser, AUTH_USER, whoami, getCredits, getNewsletter, getCarrerguide, getInvoices, getCategories, getCompanies, getReferrals, scrapFilter, filterCredit, filterCompany, filterTransaction, scrapLink, findProfileByUser, filterChatgpt, filterUser, filterProfile, filterReferral, cancelarAssinatura, recuperarHistoricoDeCobrancas, verificarStatusCliente, filterRecommendation, filterCategory, CREATE_CHAT, UPDATE_CHAT, REMOVE_CHAT, filterChat, TOGGLE_FAVORITE };
